import { render } from "./SubmenuOrganicGroup.vue?vue&type=template&id=7677ddfc"
import script from "./SubmenuOrganicGroup.vue?vue&type=script&lang=js"
export * from "./SubmenuOrganicGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__